

import { GroupModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { groupsStore } from '@/libs/groups/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import GroupDialog from '../components/GroupDialog.vue';
import { Guid } from '@/libs/common/functions/guid';
import TenantUserSelect from '@/libs/common/components-smart/TenantUserSelect.vue';

@Component({
    components: {
        GroupDialog,
        TenantUserSelect
    }
})
export default class Groups extends Page {

    get headers() {
        return [
            { text: this.$i18n.t("groups.name"), value: "name", align: "left", sortable: false },
            { text: this.$i18n.t("groups.groupUsers"), value: "groupUsers", align: "left", sortable: false },
            { text: "", value: "id", align: "left", sortable: false },
        ];
    }
    itemsPerPage = 10;
    selectedTenantUserId = '';

    get groups (): GroupModel[] {
        let allGroups = [...groupsStore.useGetter(CrudGetter.Data)];
        if (this.selectedTenantUserId !== '') {
            allGroups = allGroups.filter(group =>
                (group.groupUsers ?? []).some((gu: any) => gu?.tenantUserId === this.selectedTenantUserId)
            );
        }
        return allGroups;
    }

    get totalRows (): number {
        return ({...groupsStore.useGetter(CrudGetter.DataStats)} as CrudDataStats)?.rowCount;
    }

    mounted () {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load () {
        groupsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<GroupModel>({ field: "name", index: 1, order: "asc" }, this.getFilters());
    }

    open (item: GroupModel) {
        this.dialog.open(item.id!);
    }

    createItemClick () {
        this.dialog.open(Guid.EmptyGuid());
    }

    @Prop() tenantId!: string;
    @Ref() dialog!: GroupDialog;

    @Watch("itemsPerPage")
    itemsPerPageChanged (v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return groupsStore.useGetter(CrudGetter.Pending);
    }

}
